document.addEventListener('DOMContentLoaded', () => {
  const intro = document.querySelector('[data-intro]');
  const hideIntro = () => { if (intro) intro.classList.add('is-hidden'); };
  if (intro) {
    if (sessionStorage.getItem('duvise-intro-seen')) hideIntro();
    else { sessionStorage.setItem('duvise-intro-seen', '1'); setTimeout(hideIntro, 4800); }
    intro.querySelector('[data-intro-skip]')?.addEventListener('click', hideIntro);
  }
  const gate = document.querySelector('[data-gate]');
  const enter = () => { gate?.classList.add('is-hidden'); sessionStorage.setItem('duvise-entered', '1'); };
  if (gate && sessionStorage.getItem('duvise-entered')) gate.classList.add('is-hidden');
  document.querySelector('[data-enter-store]')?.addEventListener('click', enter);
  const countdown = document.querySelector('[data-countdown]');
  if (countdown) {
    const target = new Date(countdown.dataset.countdown).getTime();
    const fields = countdown.querySelectorAll('b');
    const update = () => {
      const distance = Math.max(0, target - Date.now());
      const values = [Math.floor(distance / 86400000), Math.floor(distance / 3600000) % 24, Math.floor(distance / 60000) % 60, Math.floor(distance / 1000) % 60];
      fields.forEach((field, index) => field.textContent = String(values[index]).padStart(2, '0'));
    };
    update(); setInterval(update, 1000);
  }
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('.site-nav');
  toggle?.addEventListener('click', () => { const open = nav?.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', String(Boolean(open))); toggle.textContent = open ? 'Close' : 'Menu'; });

  const drawers = document.querySelectorAll('.drawer');
  const backdrop = document.querySelector('.drawer-backdrop');
  const closeDrawers = () => {
    drawers.forEach(drawer => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); });
    if (backdrop) backdrop.hidden = true;
  };
  const openDrawer = drawer => {
    closeDrawers();
    drawer?.classList.add('is-open');
    drawer?.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.hidden = false;
  };
  document.querySelector('[data-search-open]')?.addEventListener('click', () => openDrawer(document.querySelector('[data-search-drawer]')));
  document.querySelector('[data-cart-open]')?.addEventListener('click', () => openDrawer(document.querySelector('[data-cart-drawer]')));
  document.querySelectorAll('[data-drawer-close]').forEach(button => button.addEventListener('click', closeDrawers));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { closeDrawers(); document.querySelector('[data-lightbox]')?.close(); } });

  const searchInput = document.querySelector('[data-product-search]');
  searchInput?.addEventListener('input', () => {
    const query = searchInput.value.trim().toLowerCase();
    document.querySelectorAll('[data-search-item]').forEach(item => { item.hidden = !item.dataset.title.includes(query); });
  });

  document.querySelector('[data-product-back]')?.addEventListener('click', () => {
    if (history.length > 1) history.back(); else location.href = '/collections/all';
  });

  const lightbox = document.querySelector('[data-lightbox]');
  document.querySelectorAll('[data-lightbox-src]').forEach(button => button.addEventListener('click', () => {
    const image = lightbox?.querySelector('img');
    if (image) image.src = button.dataset.lightboxSrc;
    lightbox?.showModal();
  }));
  document.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
  lightbox?.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });

  const productForm = document.querySelector('.product-buy form');
  productForm?.addEventListener('submit', async event => {
    event.preventDefault();
    const submit = productForm.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(productForm) });
      if (!response.ok) throw new Error('Unable to add item');
      const cart = await fetch('/cart.js').then(result => result.json());
      document.querySelectorAll('[data-cart-count]').forEach(count => count.textContent = cart.item_count);
      const lines = document.querySelector('[data-cart-lines]');
      if (lines) lines.innerHTML = cart.items.map(item => `<a class="drawer-cart-line" href="${item.url}"><span>${item.product_title}${item.variant_title ? ` / ${item.variant_title}` : ''}</span><b>$${(item.final_line_price / 100).toFixed(2)}</b></a>`).join('');
      openDrawer(document.querySelector('[data-cart-drawer]'));
    } catch (error) { productForm.submit(); }
    finally { if (submit) submit.disabled = false; }
  });
});
